export const colorList = [
	"Black",
	"White",
	"Red",
	"Green",
	"Blue",
	"Yellow",
	"Purple",
	"Orange",
	"Gray",
	"Silver",
	"Gold",
	"Brown",
	"Pink",
	"Cyan",
	"Magenta",
	"Indigo",
	"Teal",
	"Lime",
	"Maroon",
	"Olive",
	"Navy",
	"Violet",
	"Peach",
	"Coral",
	"Lemon",
	"Plum",
	"Salmon",
	"Tan",
	"SkyBlue",
	"SlateGray",
];
